export const STRUCTURED_CARE_PLANNER_FLAG_KEY = 'structured_care_planner_v1' as const;

/**
 * Clinical compiler rollout is tenant-only and fail-closed: each provider is
 * switched on by its own row, never by a global row. On 12 September 2026 the
 * owner switched it on for every tenant with clients.
 */
export function isTenantScopedStructuredCarePlannerFlag(flagKey: string): boolean {
  return flagKey === STRUCTURED_CARE_PLANNER_FLAG_KEY;
}
